import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesNoteBook: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.2 30.48V18.29h3.04V3.05H28.2V1.52h-1.53v28.96Zm0-25.91h1.52v3.05H28.2Zm0 4.57h1.52v3.05H28.2Zm0 4.58h1.52v3.04H28.2ZM3.815 30.48h22.85V32H3.815Zm18.28-6.1h1.53v1.53h-1.53Zm-3.05 3.05h4.58v1.52h-4.58ZM22.1 16.76v-1.52h1.53V7.62H22.1V6.1H9.9v1.52H8.385v7.62H9.9v1.52ZM11.435 9.14h9.14v1.53h-9.14Zm0 3.05h9.14v1.53h-9.14Zm7.61 12.19h1.53v1.53h-1.53ZM3.815 0h22.85v1.52H3.815Zm1.52 27.43v-1.52h-1.52v-4.58h1.52v-1.52h-1.52v-3.05h1.52v-1.52h-1.52v-3.05h1.52v-1.52h-1.52V6.1h1.52V4.57h-1.52V1.52h-1.53v3.05H.765V6.1h1.52v4.57H.765v1.52h1.52v3.05H.765v1.52h1.52v3.05H.765v1.52h1.52v4.58H.765v1.52h1.52v3.05h1.53v-3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesNoteBook
